import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent implements OnInit {

  @Input() deleteEventName:string = '';
  @Input() deleteloader:boolean = false;
  @Input() eventTitle:string = '';
  @Input() deleteEventModelOpen:boolean = false;
  @Output() deleteEventModelClose = new EventEmitter<boolean>(false);
  @Output() deleteEventTrigger = new EventEmitter<boolean>(false);
  @ViewChild('deleteModal', { static: true }) modalTemplate: TemplateRef<any>;
  deleteEventModel:any;
  constructor(private modal: NgbModal) { }

  ngOnInit() {
  }

   ngOnChanges(changes: SimpleChanges): void {
    if (changes['deleteEventModelOpen'] && changes['deleteEventModelOpen'].currentValue) {
      this.openModelDelete();
    }
      if (changes['deleteEventModelOpen'] && !changes['deleteEventModelOpen'].currentValue) {
      this.closeModalPopup();
    }
  }

  //FOR DELETE EVENT open
  openModelDelete() {
    this.deleteEventModel = this.modal.open(this.modalTemplate, { size: "sm", centered: true });
  }

    //FOR DELETE EVENT cose
  closeModalPopup() {
    this.deleteEventModelClose.emit(true);
    if(this.deleteEventModel){
      this.deleteEventModel.close();
    }
  }

  onDeleteEvent(){
    this.deleteEventTrigger.emit(true);
  }

}
